// Comparativo "mesmo período" do Relatório de Vendas (pedido do Vagner,
// 06/10/2026): mês atual do dia 1 até hoje × mês anterior do dia 1 até o
// mesmo dia; na visão do ano, ano atual até hoje × ano anterior até a mesma
// data. Só existe no período EM ANDAMENTO — em mês ou ano fechado daria o
// mesmo número do card "vs mês anterior", que segue como sempre foi (mês
// inteiro × mês inteiro: desproporcional no começo do mês, mas ele gosta).

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const p2 = (n) => String(n).padStart(2, '0');
const ultimoDia = (ano, mes) => new Date(ano, mes, 0).getDate(); // mes de 1 a 12

// Hoje em 'AAAA-MM-DD' no fuso de Brasília (a data_venda é gravada em −3h)
export function hojeBrasilia() {
  return new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);
}

// vendas: já com os filtros de consultor/serviço (sem filtro de data)
// ano/mes: a seleção da tela (mes vazio = ano inteiro)
// Devolve null quando o período selecionado não está em andamento.
export function comparativoMesmoPeriodo(vendas, ano, mes, hoje = hojeBrasilia()) {
  const [hA, hM, hD] = hoje.split('-').map(Number);
  const soma = (passa) => vendas.filter(v => passa(String(v.data_venda || ''))).reduce((s, v) => s + (Number(v.valor) || 0), 0);
  let atual, antes, rotuloAtual, rotuloAntes;
  if (mes) {
    if (+ano !== hA || +mes !== hM) return null;
    let aAnt = hA, mAnt = hM - 1;
    if (mAnt === 0) { mAnt = 12; aAnt -= 1; }
    // Mês anterior mais curto (30/03 × fevereiro): vai até o último dia dele
    const diaAnt = Math.min(hD, ultimoDia(aAnt, mAnt));
    atual = soma(d => d.startsWith(`${hA}-${p2(hM)}-`) && +d.slice(8, 10) <= hD);
    antes = soma(d => d.startsWith(`${aAnt}-${p2(mAnt)}-`) && +d.slice(8, 10) <= diaAnt);
    rotuloAtual = `1–${hD}/${MESES[hM - 1]}`;
    rotuloAntes = `1–${diaAnt}/${MESES[mAnt - 1]}`;
  } else {
    if (+ano !== hA) return null;
    const aAnt = hA - 1;
    const diaAnt = Math.min(hD, ultimoDia(aAnt, hM)); // 29/02 × ano sem 29/02
    atual = soma(d => d.startsWith(`${hA}-`) && d.slice(5, 10) <= `${p2(hM)}-${p2(hD)}`);
    antes = soma(d => d.startsWith(`${aAnt}-`) && d.slice(5, 10) <= `${p2(hM)}-${p2(diaAnt)}`);
    rotuloAtual = `até ${p2(hD)}/${p2(hM)}/${hA}`;
    rotuloAntes = `até ${p2(diaAnt)}/${p2(hM)}/${aAnt}`;
  }
  return { atual, antes, delta: antes > 0 ? (atual - antes) / antes : null, rotuloAtual, rotuloAntes };
}
